import PrimaryButton from 'core-system/Button/PrimaryButton'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import Text from 'core-system/Text'
import React from 'react'
import { useDispatch } from 'react-redux'
import { StaticAssetsUrl } from 'redux/config/services/Constants'
import { userActions } from 'redux/user/userSlice'
import { Locations } from 'shared/Router/Locations'
import styled from 'styled-components'

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 76vh;
`

const Container = styled.div`
  width: 100%;
  padding: 2rem 3.25rem 3.25rem;
  background-color: ${(props) => props.theme.palette.white};
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => props.theme.palette.grey.grey300};
  box-shadow: ${(props) => props.theme.dropShadows.normal};
  border-radius: 0.9375rem;
  max-width: ${(props) => props.theme.pxToRem(636)};
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const StyledImage = styled.img`
  position: absolute;
  top: ${(props) => props.theme.pxToRem(-85)};
  margin-left: 2rem;
`

interface ErrorViewProps {
  errorMessage?: string
  description?: React.ReactNode
  showLogoutButton?: boolean
  actionButton?: {
    label: string
    onClick: () => void
  }
}

const DEFAULT_DESCRIPTION = (
  <>
    If you keep getting this message please contact us via chat at the bottom
    right corner of your screen or email us at{' '}
    <a href='mailto:help@movewithfleet.com'>help@movewithfleet.com</a>
  </>
)

const ErrorView = React.memo(
  ({
    errorMessage = "Oops! Something doesn't seem right on this page. Please refresh your browser.",
    description = DEFAULT_DESCRIPTION,
    showLogoutButton = false,
    actionButton,
  }: ErrorViewProps) => {
    const dispatch = useDispatch()
    return (
      <Content>
        <Container>
          <StyledImage
            alt={'error'}
            src={`${StaticAssetsUrl}/shared/error.png`}
          />
          <Text
            variant='action3'
            width='70%'
            paddingTop='4rem'
            marginBottom='1rem'
          >
            {errorMessage}
          </Text>
          <Text variant='body1' width='80%'>
            {description}
          </Text>
          {actionButton && (
            <PrimaryButton
              onClick={actionButton.onClick}
              style={{ marginTop: '2rem' }}
            >
              {actionButton.label}
            </PrimaryButton>
          )}
          {showLogoutButton && (
            <SecondaryButton
              onClick={() => {
                dispatch(userActions.logout())
                window.location.href = Locations.Login
              }}
              style={{
                marginTop: '2rem',
              }}
            >
              Logout
            </SecondaryButton>
          )}
        </Container>
      </Content>
    )
  }
)

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  ErrorView.displayName = 'ErrorView'
}

export default ErrorView
